@if (!isMobile) {
<div class="accept-collections-modal">
    <div class="header-container">
        <div class="header-title">{{'COLLECTION_REPORT.ACCEPT' | translate }}</div>
    </div>
    <div class="content-container">
        <div class="form-container">
            <div class="form-title" rtlDiv>{{'COLLECTION_REPORT.ACCEPT_CONFIRMATION' | translate }}</div>
            <div>
                <table class="table" mat-table #table [dataSource]="dataSource" matSort matSortStart="asc"
                    matSortDisableClear matSortActive="bin_name" (matSortChange)="sortData($event)"
                    matSortDirection="desc" rtlDiv>
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="bin_name" class="th-title space">
                            {{ 'SITE_MANAGMENT.BIN_NAME' | translate }} </th>
                        <td mat-cell *matCellDef="let element" class="td-value">
                            <span class="cut-txt binNameHref">
                                {{element ? element.bin_name : ''}}
                            </span>                            
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="clearing">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="bin_collection_time" class="th-title space"> {{
                          'LIVE_INFO.LIST_COLLECTION_TIME' | translate }} </th>
                        <td mat-cell *matCellDef="let element" class="td-value space">
                          {{currentLang == 'iw' && element ? element.bin_collection_time_he : element.bin_collection_time}}
                        </td>
                      </ng-container>
                    <ng-container matColumnDef="address">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="bin_address" class="th-title space">
                            {{ 'LIST_COLUMNS.ADDRESS' | translate }} </th>
                        <td mat-cell *matCellDef="let element" class="td-value space">
                            <span title="{{element ? element.bin_address : ''}}" class="cut-txt"> 
                                {{element ? element.bin_address : ''}}
                            </span>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>
                <div>
                    <app-pagination [chosenBins]="filteredData" (pageChange)='onPageChange($event)'
                        [filesPerPage]="5"></app-pagination>
                </div>
            </div>
        </div>
        <div class="btns-container" rtlDiv>
            <div class="cancel-btn" (click)="closeModal()">{{ 'TRUCK_MAP.CANCEL' | translate }}</div>
            <div class="apply-btn" (click)="applyChanges()">{{'COLLECTION_REPORT.ACCEPT' | translate }}</div>
        </div>
    </div>
</div>
}

@if (isMobile) {}